import { Reveal } from "@/components/Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { CONTACT } from "@/data/content";

export const FaqAccordion = ({ items }) => (
  <Reveal>
    <div className="card overflow-hidden">
      <Accordion type="single" collapsible className="px-6 md:px-8">
        {items.map((item, i) => (
          <AccordionItem key={item.q} value={`item-${i}`} data-testid={`faq-item-${i + 1}`} className="border-slate-200">
            <AccordionTrigger data-testid={`faq-trigger-${i + 1}`} className="py-5 text-left font-display text-base font-semibold tracking-tight hover:no-underline md:text-lg">
              {item.q}
            </AccordionTrigger>
            <AccordionContent data-testid={`faq-answer-${i + 1}`} className="text-sm leading-relaxed text-slate-600 md:text-base">
              {item.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
      <div className="border-t border-slate-200 bg-cream px-6 py-4 md:px-8">
        <p className="text-sm text-slate-600">
          Not answered here? Call <a href={CONTACT.phoneHref} className="font-medium text-brand hover:underline">{CONTACT.phone}</a> or email{" "}
          <a href={`mailto:${CONTACT.email}`} className="font-medium text-brand hover:underline">{CONTACT.email}</a>.
        </p>
      </div>
    </div>
  </Reveal>
);
